export const UploadDeadletter = {
  namespaced: true,

  state: {
    list: [],
    pagination: {},
    loadedList: false,
  },

  getters: {
    paginationTotal: ({ pagination }) => pagination.total ?? 0,
    loadedList: ({ loadedList }) => loadedList,
    list: ({ list }) => list,
  },

  mutations: {
    setPagination: (state, pagination) => (state.pagination = pagination),
    setLoadedList: (state, bool) => (state.loadedList = bool),
    setList: (state, list) => (state.list = list),
    resetList: (state) => (state.list = []),
  },

  actions: {
    async listDeadletter({ commit }, { filter, page, perPage, sortBy, sortDesc }) {
      let pagination = {};
      let list = [];

      commit('setLoadedList', false);
      commit('resetList');

      try {
        const {
          data: { data, meta, links },
        } = await this._vm.$api('dicom.studies.imports.failed', {
          version: '1.0',
          sortDesc,
          perPage,
          filter,
          sortBy,
          page,
        });

        list = data;
        pagination = { ...meta, ...links };
      } catch (err) {
        console.error(err);
      }

      commit('setPagination', pagination);
      commit('setList', list);

      commit('setLoadedList', true);
    },
  },
};
